<template>
<div class="chapter">
<div class="inner_page">
<p class="ipadfp"><img alt="Cover: Springwater Seasons, by Linda Lael Miller" class="imagefp" src="images/9781439106952.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// cover.vue?2b67ce2c